export function setupCourseOverview() {
  /** Move Course Overview out of tabs, add data attribute */
  const tabsContainer = document.querySelector(".section-container.tabs");
  const curriculumHeader = document.querySelector('[data-header="Curriculum"]');

  /** But only do all this stuff if we can */
  if (tabsContainer && curriculumHeader) {
    const courseDescription = document.querySelector(".section-container.tabs .course-long-description-header").parentElement.parentElement;
    courseDescription.setAttribute("data-course-overview", "");
    tabsContainer.prepend(courseDescription);

    /** Move Course Curriculum */
    const curriculumList = document.querySelector("#curriculum-list");
    curriculumHeader.insertAdjacentElement('afterend', curriculumList);

    /** Setup Sidebar with Cards */
    const courseOverview = document.querySelector('[data-course-overview=""]');
    let courseOverviewSidebar = document.createElement('div');
    courseOverviewSidebar.classList.add('as-course-overview__sidebar');

    const pathCard = `
    <a class="as-module-card as-card as-card--dark" href="/path/airflow-101">
      <div class="as-module-card__content as-flex-container">
        <img src="https://astronomer.github.io/academy-theme/dist/icons/module.svg" width="48" height="48" alt="" class="as-module-card__badge" />
        <p class="as-module-card__text">This module is part of the Airflow 101 Learning Path</p>
      </div>
    </a>
  `

    const preRequisitesList = document.querySelector('[data-pre-requisites-list=""]');
    const preRequisitesCard = `
    <div class="as-pre-requisites-card as-card as-card--gray">
      <h2>Prerequisites</h2>
      ${preRequisitesList.outerHTML}
    </div>
  `;

    const instructorCard = `
    <div class="as-instructor-card as-card">
      <h2>Instructor</h2>
      <div class="as-instructor-card__profile as-flex-container">
        <img src="https://astronomer.github.io/academy-theme/dist/images/marc-lamberti.jpg" alt="Marc Lamberti" width="64" height="64" class="as-circle" />
        <p class="as-instructor-card__name">Marc Lamberti</p>
      </div>
      <p>Marc is Head of Customer Education at Astronomer and creator of the Astronomer Certification for Apache Airflow Fundamentals. He wants to help data engineers get started with Airflow as easily and smoothly as possible and make sure they have everything they need to implement Airflow in their organizations.</p>
    </div>
  `;

    courseOverviewSidebar.innerHTML = pathCard + preRequisitesCard + instructorCard;

    courseOverview.append(courseOverviewSidebar);
  }
}